import React from 'react';
import { IBalanceInstruction } from '../../../../../../sp-types/balanceFlowType';
import { Cell, Row } from 'react-table';
import { TaskAlt } from '@mui/icons-material';

const MAX_2_DIGIT = { maximumFractionDigits: 2 };
const max2Digit = (num: number): number => Math.floor(num * 100) / 100;
interface EditExecuteRowProps {
  row: Row<IBalanceInstruction>;
  onUpdateExecution?: (_instrument: string, _contractCount?: number, _price?: number) => void;
}

export const EditExecuteRow: React.FC<EditExecuteRowProps> = ({ row, onUpdateExecution }) => {
  const viewCols = ['Expiry date', 'Instrument'];
  const editCols = ['numberOfContracts', 'lastPrice'];

  const valueChange = (cell: Cell<IBalanceInstruction, any>, value: number) => {
    const contractCount = cell.column.id === 'numberOfContracts' ? value : undefined;
    const price = cell.column.id === 'lastPrice' ? max2Digit(value) : undefined;

    onUpdateExecution?.(cell.row.original.instrumentId, contractCount, price);
  };

  const is0Value = (cell: Cell<IBalanceInstruction, any>): boolean => {
    const result =
      cell.column.id === 'numberOfContracts'
        ? !cell.row.original.executedNumberOfContracts || cell.row.original.executedNumberOfContracts === 0
        : !cell.row.original.executedPrice || cell.row.original.executedPrice === 0;

    return result;
  };

  const renderCell = (cell: Cell<IBalanceInstruction, any>) => {
    return viewCols.includes(cell.column.id) ? (
      <div className="px-2">{cell.render('Cell')}</div>
    ) : cell.column.id === 'action' ? (
      <div className="px-2 flex justify-between">
        {cell.render('Cell')}
        {(cell.row.original.executedNumberOfContracts || 0) > 0 && (
          <TaskAlt sx={{ fill: '#4ACB3E', height: '1.25rem' }} />
        )}
      </div>
    ) : editCols.includes(cell.column.id) ? (
      <input
        type="number"
        value={
          cell.column.id === 'numberOfContracts'
            ? cell.row.original.executedNumberOfContracts
            : cell.row.original.executedPrice
        }
        className={`ring-1 focus:outline-none mx-auto flex-1 rounded-md w-full p-1 px-2 ${
          is0Value(cell) ? 'ring-red' : 'ring-secondary'
        }`}
        onChange={({ target }) => valueChange(cell, +target.value)}
      />
    ) : cell.column.id === 'Quantity' ? (
      <div className="px-2">
        {(
          (cell.row.original.executedNumberOfContracts || 0) * (cell.row.original.quantityPerContract || 1)
        ).toLocaleString()}
        {/* TODO: add unit from materialsMap*/}
      </div>
    ) : cell.column.id === 'Total Price' ? (
      <div className="px-2">
        $
        {(
          (cell.row.original.executedNumberOfContracts || 0) *
          (cell.row.original.quantityPerContract || 1) *
          (cell.row.original.executedPrice || 0)
        ).toLocaleString(undefined, MAX_2_DIGIT)}
      </div>
    ) : (
      ''
    );
  };

  return (
    <tr>
      {row.cells.map((cell: Cell<IBalanceInstruction, any>) => (
        <td
          key={cell.column.id}
          className={`text-sm p-1 mx-auto overflow-hidden border no-wrap ${
            (cell.row.original.executedNumberOfContracts || 0) > 0 ? 'bg-green-50' : 'bg-gray-125'
          }`}
        >
          {renderCell(cell)}
        </td>
      ))}
    </tr>
  );
};
